/**
 * 全局配置文件
 */

const config = {
    title: "长三角算力公共服务平台",
    development: {
        ssoLoginUrl:
            "http://192.168.155.170/api/authn/getCode?client_id=bd55a5973e324e4b88f6ee1cb718a300&redirect_uri=http://192.168.155.171:48001&app_biz_no=XXXX", //测试环境 -单点登录地址
        corpAuthUrl: "http://192.168.155.170/corpAuth", //测试环境 -企业认证地址
        ncnpServerUrl: "http://157.0.19.2:10545", //测试环境 -国家算力一体化平台地址（welcome/task_id=login 等入口）
    },
    production: {
        ssoLoginUrl:
            "https://ca.ssc.net.cn/api/authn/getCode?client_id=7680fff7da9e49d6b7b2f83d6f5c0a93&redirect_uri=https://csjcs.ssc.net.cn&app_biz_no=202505280001", //生产环境 -单点登录地址
        corpAuthUrl: "https://ca.ssc.net.cn/corpAuth", //生产环境 -企业认证地址
        ncnpServerUrl: "https://www.ncnp.cn", //生产环境 -国家算力一体化平台地址（welcome/task_id=login 等入口）
    },
};

function getWebsiteConfig() {
    const hostname = window.location.hostname;
    // Add your production domain check here
    if (hostname === "csjcs.ssc.net.cn") {
        return {
            ...config,
            ssoLoginUrl: config.production.ssoLoginUrl,
            corpAuthUrl: config.production.corpAuthUrl,
            ncnpServerUrl: config.production.ncnpServerUrl,
        };
    } else {
        // Default to development/test environment
        return {
            ...config,
            ssoLoginUrl: config.development.ssoLoginUrl,
            corpAuthUrl: config.development.corpAuthUrl,
            ncnpServerUrl: config.development.ncnpServerUrl,
        };
    }
}

export default getWebsiteConfig();
